import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { getMessage, resetForm } from "../../features/subscribe/subscribeSlice";

const SuccessSubscribe = () => {
  const dispatch = useDispatch();
  const message = useSelector(getMessage);
  return (
    <div className="relative">
      <div className="bg-white h-full rounded-lg py-10">
        <div className="flex flex-col items-center justify-center h-full">
          <img src="/images/success.jpg" alt="" />
          <h2 className="font-bold mt-5 text-lg">{message}</h2>
          <button
            onClick={() => dispatch(resetForm())}
            className="font-light text-sm  mt-3 text-blue-400 hover:text-blue-500 hover:font-bold transition-all duration-200 px-3 py-2 hover:bg-gray-100 active:bg-blue-400 active:text-white active:shadow-md rounded-md"
          >
            [Close]
          </button>
        </div>
      </div>
    </div>
  );
};

export default SuccessSubscribe;
